import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import PropTypes from 'prop-types';
import CompanyBanner from "./CompanyBanner";
import useWhiteLabeling from "../hooks/useWhiteLabeling";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
    goBack: {
        id: "Palaa takaisin",
        defaultMessage: "Palaa takaisin"
    }
});

/**
 * CompanyInfoModal component fetches and displays company information in a modal.
 * It includes a logo, title, description, and a banner.
 */
const CompanyInfoModal = (props) => {
    const [logoUrl, setLogoUrl] = React.useState(null);
    const { fetchWhiteLabelingImageData } = useWhiteLabeling();
    const lng = props.intl.formatMessage;

    const logoAssetId = props.data?.brandingSettings?.logo_asset_id;
    const content = Array.isArray(props.data?.companyInfo?.content)
        ? props.data.companyInfo.content[0]
        : props.data?.companyInfo?.content;
    const hasLogoAsset = logoAssetId !== undefined &&
        logoAssetId !== null &&
        parseInt(logoAssetId) !== 0;

    useEffect(() => {
        const fetchLogo  = async () => {
            // Fetch logo data from API
            const imageUrl = await fetchWhiteLabelingImageData(logoAssetId);
            setLogoUrl(imageUrl);
        }
        void fetchLogo();
    }, [logoAssetId]);

    const handleHide = () => {
        props.onHide();
    }

    if (!props.data) {
        return null;
    }

    return (
        <Modal show={props.show} onHide={handleHide} id='company-info-modal'>
            <Modal.Header closeButton>
                <Button
                    className="modal-back"
                    onClick={handleHide}
                    aria-label={lng(messages.goBack)}
                >
                    <FontAwesomeIcon icon={far.faArrowLeft} aria-hidden="true" /> {lng(messages.goBack)}
                </Button>
                {hasLogoAsset && (
                    <img
                        src={logoUrl}
                        alt="Company Logo"
                        width={props.logoWidth}
                        height={props.logoHeight}
                    />
                )}
            </Modal.Header>
            <Modal.Body>
                <Modal.Title>{props.companyName}</Modal.Title>
                {content !== undefined && (
                    <p dangerouslySetInnerHTML={{ __html: content }}></p>
                )}
                {props.data?.banners?.length > 0 && (
                    <div className='company-info-banner-container'>
                        <CompanyBanner banner={props.data.banners[0]} />
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

CompanyInfoModal.propTypes = {
    intl: PropTypes.object.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    companyName: PropTypes.string,
    data: PropTypes.object,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number
};

export default injectIntl(CompanyInfoModal);
